import "./Pages.css";

const Services = () => {
  return (
    <div className="services-page">

      {/* Hero Section */}
      <section className="services-hero">
        <h1>Our Services</h1>

        <p>
          We provide end-to-end technology solutions that help businesses
          automate operations, improve customer engagement, and scale their
          e-commerce business with confidence.
        </p>
      </section>

      {/* Services */}
      <section className="services-section">

        <div className="services-grid">

          <div className="service-box">
            <h2>🛒 E-commerce Solutions</h2>

            <p>
              We build secure, scalable, and user-friendly e-commerce
              platforms tailored to your business requirements.
            </p>

            <ul>
              <li>Custom Online Store Development</li>
              <li>Multi-Vendor Marketplace</li>
              <li>Payment Gateway Integration</li>
              <li>Inventory Management</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>📦 Order Management System</h2>

            <p>
              Manage your complete order lifecycle from one centralized
              dashboard.
            </p>

            <ul>
              <li>Order Processing</li>
              <li>Inventory Tracking</li>
              <li>Shipping & Courier Integration</li>
              <li>Returns & NDR Management</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>📩 SMS Services</h2>

            <p>
              Deliver instant SMS notifications for customers and business
              operations.
            </p>

            <ul>
              <li>OTP SMS</li>
              <li>Transactional SMS</li>
              <li>Promotional SMS</li>
              <li>Delivery Notifications</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>📧 Email Services</h2>

            <p>
              Automate business communication using professional email
              solutions.
            </p>

            <ul>
              <li>Order Confirmation</li>
              <li>Invoice Emails</li>
              <li>Marketing Campaigns</li>
              <li>Newsletter Automation</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>💬 WhatsApp Business API</h2>

            <p>
              Connect with customers instantly using WhatsApp Business
              messaging.
            </p>

            <ul>
              <li>Order Updates</li>
              <li>Customer Support</li>
              <li>Promotional Messages</li>
              <li>Automated Notifications</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>🔗 API Integration</h2>

            <p>
              Connect your applications with third-party platforms for
              seamless business operations.
            </p>

            <ul>
              <li>Courier API</li>
              <li>Payment Gateway</li>
              <li>SMS & Email API</li>
              <li>ERP & CRM Integration</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>⚙ Business Automation</h2>

            <p>
              Reduce manual work with intelligent workflow automation and
              business process optimization.
            </p>

            <ul>
              <li>Workflow Automation</li>
              <li>Task Scheduling</li>
              <li>Data Synchronization</li>
              <li>Report Generation</li>
            </ul>
          </div>

          <div className="service-box">
            <h2>☁ Cloud Solutions</h2>

            <p>
              Deploy secure, scalable, and high-performance cloud
              applications.
            </p>

            <ul>
              <li>Cloud Hosting</li>
              <li>Database Management</li>
              <li>Application Deployment</li>
              <li>Backup & Security</li>
            </ul>
          </div>

        </div>

      </section>

    </div>
  );
};

export default Services;